import api from "./axios";

export const getConstantReportReasonTypes = async () => {
    try {
        const response = await api.get("/api/v2/constant/reasons");
        return response.data;
    } catch (error) {
        console.error(
            error.response?.data?.message || "Error fetching reason types."
        );
    }
};

export const getConstantStudies = async () => {
    try {
        const response = await api.get("/api/v2/constant/studies");
        return response.data;
    } catch (error) {
        console.error(
            error.response?.data?.message || "Error fetching studies."
        );
    }
};

export const getConstantGrowths = async () => {
    try {
        const response = await api.get("/api/v2/constant/growths");
        return response.data;
    } catch (error) {
        console.error(
            error.response?.data?.message || "Error fetching growths."
        );
    }
};

export const getConstantJobs = async () => {
    try {
        const response = await api.get("/api/v2/constant/jobs");
        return response.data;
    } catch (error) {
        console.error(
            error.response?.data?.message || "Error fetching jobs."
        );
    }
};

export const getConstantWantKids = async () => {
    try {
        const response = await api.get("/api/v2/constant/want-kids");
        return response.data;
    } catch (error) {
        console.error(
            error.response?.data?.message || "Error fetching jobs."
        );
    }
};

export const getConstantHaveKids = async () => {
    try {
        const response = await api.get("/api/v2/constant/have-kids");
        return response.data;
    } catch (error) {
        console.error(
            error.response?.data?.message || "Error fetching jobs."
        );
    }
};


